import { render, staticRenderFns } from "./dialogWorkFlowLabelGroup.vue?vue&type=template&id=49bcf086&"
import script from "./dialogWorkFlowLabelGroup.vue?vue&type=script&lang=js&"
export * from "./dialogWorkFlowLabelGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports